import React from 'react';
import styled from 'styled-components';

import { Overline } from '../Typography/Typography';

type Props = {
    label: string | React.ReactNode;
};

const LabelContainer = styled.div`
    padding: 12px 18px;
`;

export const DropdownSelectLabel = ({ label }: Props) => {
    return (
        <LabelContainer>
            <Overline>{label}</Overline>
        </LabelContainer>
    );
};
